export const BATCH_ENVIRONMENTS = {
  prod: {
    label: 'Production (trapi.research.microsoft.com)',
    baseUrl: 'https://trapi.research.microsoft.com/batch',
  },
  dev: {
    label: 'Development (dev-trapi.research.microsoft.com)',
    baseUrl: 'https://dev-trapi.research.microsoft.com/batch',
  },
} as const;

export type BatchEnvironment = keyof typeof BATCH_ENVIRONMENTS;

export function getBatchBaseUrl(environment: BatchEnvironment): string {
  return BATCH_ENVIRONMENTS[environment].baseUrl;
}

export function getBatchOrigin(environment: BatchEnvironment): string {
  const baseUrl = getBatchBaseUrl(environment);
  return baseUrl.endsWith('/batch') ? baseUrl.slice(0, baseUrl.length - '/batch'.length) : baseUrl;
}
